import { RootState } from "../../../utils/types/root-state";

export const getProfileState = (state: RootState) => state.profile;